
// 手机号码验证
export function isCellPhone(val){
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
    } else {
        return true;
    }
}

// 身份证验证
export function isCard(card){
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  
    if(reg.test(card) === false) {  
        return  false;  
    }else{
        return true
    }
}
